import { render } from "./component.vue?vue&type=template&id=71d2e50c&ts=true"
import script from "./component.vue?vue&type=script&lang=ts"
export * from "./component.vue?vue&type=script&lang=ts"

import "./component.vue?vue&type=style&index=0&id=71d2e50c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__